import React from 'react';
import { bool, shape, string } from 'prop-types';

const Transfer = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 7L3.41 8.41L6 5.83L6 22L8 22L8 5.83L10.59 8.42L12 7L7 2L2 7Z" fill="currentColor" />
    <path d="M12 17L13.41 15.59L16 18.17L16 2L18 2L18 18.17L20.59 15.58L22 17L17 22L12 17Z" fill="currentColor" />
  </svg>
);

Transfer.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Transfer;
